export class IntegrationMessageConfig {
  constructor({
        id= null, 
        active= `true`, 
        tryCountLimit= ``, 
        messageDefinition= ``,
        systemType = '',
        instance = '',
        messageDataConversions = []
    } = {}) {
    this.id = id;
    this.active = active;
    this.tryCountLimit = tryCountLimit;
    this.messageDefinition = messageDefinition;
    this.systemType = systemType;
    this.instance = instance;
    this.messageDataConversions = messageDataConversions;
  }
}
export function gridFields() {
  return Object.freeze([
      "state",
      {
        key: 'id',
        label: 'ID',
      },
      {
        key: 'tryCountLimit',
        label: 'Try Count Limit'
      },
      {
        key: 'messageDefinition.name',
        label: 'Message type',
        sortable: true
      },
      "active"
  ]);
}
export const fields = Object.freeze(Object.keys(new IntegrationMessageConfig()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.systemTypeFilter',
  'filter.instanceFilter',
  'filter.typeFilter'
];
export const filter = {
  'systemTypeFilter': "",
  'instanceFilter': "",
  'typeFilter': ""
};